import './styles.css';

import React from 'react';
import ShowShelf from './ShowShelf';
import { IShow } from 'interface/cast';

interface IProps {
  shows: IShow[];
}

const ShowShelves = ({ shows }: IProps) => {
  return (
    <div className='nc-shelves'>
      {shows?.map((show) => (
        <ShowShelf key={show.id} show={show} />
      ))}
    </div>
  );
};

export default ShowShelves;
